import {
  BookOpen,
  Globe,
  Heart,
  MapPin,
  Briefcase,
  Camera,
  type LucideIcon,
} from "lucide-react";

export type HomeContent = {
  announcement: { icon: LucideIcon; label: string }[];
  hero: {
    heading: string;
    headingScript: string;
    paragraph: string;
    cta: string;
  };
  services: {
    icon: LucideIcon;
    title: string;
    description: string;
    cta: string;
    href: string;
  }[];
  showcase: {
    heading: string;
    headingRest: string;
    headingScript: string;
    paragraph: string;
    bullets: { icon: LucideIcon; label: string }[];
  };
  footer: {
    taglineLine1: string;
    taglineLine2: string;
  };
};

export type FaqCategoryKey = "ogolne" | "ebooki" | "plany" | "spersonalizowane";

export type FaqItem = {
  id: string;
  category: FaqCategoryKey;
  question: string;
  answer: string;
};

export const faqCategories: { key: FaqCategoryKey; label: string; icon: LucideIcon }[] = [
  { key: "ogolne", label: "Ogólne", icon: Heart },
  { key: "ebooki", label: "E-booki", icon: BookOpen },
  { key: "plany", label: "Plany podróży", icon: MapPin },
  { key: "spersonalizowane", label: "Spersonalizowana wycieczka", icon: Briefcase },
];

export const defaultContent: HomeContent = {
  announcement: [
    { icon: BookOpen, label: "E-BOOKI, KTÓRE ZMIENIĄ TWOJE PODRÓŻE" },
    { icon: Globe, label: "OSZCZĘDZAJ CZAS, PIENIĄDZE I ENERGIĘ" },
    { icon: Heart, label: "PODRÓŻUJ LEPIEJ, NIE DROŻEJ" },
  ],
  hero: {
    heading: "Twoja podróż,",
    headingScript: "Twoje zasady.",
    paragraph: "Sprawdzone e-booki i plany podróży, które zabiorą Cię dalej.",
    cta: "ZAINSPIRUJ SIĘ",
  },
  services: [
    {
      icon: BookOpen,
      title: "E-BOOKI",
      description:
        "Praktyczne przewodniki po najciekawszych miejscach na świecie.",
      cta: "ZOBACZ E-BOOKI",
      href: "/ebooks",
    },
    {
      icon: MapPin,
      title: "PLANY PODRÓŻY",
      description:
        "Gotowe plany wycieczek z atrakcjami, mapami, noclegami i transportem.",
      cta: "ZOBACZ PLANY",
      href: "/tours",
    },
    {
      icon: Briefcase,
      title: "PERSONALIZOWANE PLANY PODRÓŻY",
      description:
        "Indywidualnie dopasowany plan do Twoich potrzeb, budżetu i marzeń.",
      cta: "ZAMÓW PLAN",
      href: "/tours/custom",
    },
  ],
  showcase: {
    heading: "Podróżuj mądrze,",
    headingRest: "pięknie i ",
    headingScript: "po swojemu.",
    paragraph:
      "Tworzymy praktyczne e-booki i gotowe plany podróży, dzięki którym zaoszczędzisz czas, pieniądze i unikniesz stresu.",
    bullets: [
      { icon: Globe, label: "Sprawdzone miejsca i aktualne informacje" },
      { icon: Heart, label: "Proste i gotowe rozwiązania" },
      { icon: Camera, label: "Więcej przygód, mniej planowania" },
    ],
  },
  footer: {
    taglineLine1: "Dołącz do naszej",
    taglineLine2: "podróżniczej społeczności!",
  },
};
